const COOKIES = {
  AUTH_TOKEN: 'authtoken',
  CSRF_TOKEN: 'csrftoken',
};

export default COOKIES;
